module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./DetailView.js"));
	}, "GiftOrderDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GiftOrderDetailView!./src/pages/Shop/GiftCheckOrder/Detail/DetailView.js
// module id = 884
// module chunks = 431